import { TextWithIconCard } from './TextWithIconCard';
import styles from './TextWithIconCards.module.css';
import { IconName } from '../ui/Icon/Icon';

type TextWithIconCardsProps = {
  heading: string;
  cards: {
    heading: string;
    text: string;
    iconName: IconName;
  }[];
};

export const TextWithIconCards = ({ heading, cards }: TextWithIconCardsProps) => {
  return (
    <div className={styles.rootLayout}>
      <p className={styles.heading}>{heading}</p>
      <div className={styles.cards}>
        {cards.map((card, index) => (
          <TextWithIconCard key={index} heading={card.heading} text={card.text} iconName={card.iconName} />
        ))}
      </div>
    </div>
  );
};
